module.exports = __webpack_public_path__ + "static/media/SkyaTheobald.1727dfe8.jpg";